import { render } from "./CustomRadioGroup.vue?vue&type=template&id=bc0c0700"
import script from "./CustomRadioGroup.vue?vue&type=script&lang=js"
export * from "./CustomRadioGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__